import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GeneralFunctionsService } from 'src/app/services/general-functions.service';
import { faFile } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-file-selector',
  templateUrl: './file-selector.component.html',
  styleUrls: ['./file-selector.component.css']
})
export class FileSelectorComponent {
  @Input() fileName: string;
  @Input() placeholderText: string;

  faFile = faFile;

  file: File;
  fileReader: FileReader;

  @Output() enableUpload: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sendFile: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private generalFunctionsService: GeneralFunctionsService,
    private translate: TranslateService
  ) { }

  handleInputChange(e: any): void {
    this.file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.checkFile();
  }

  handleReaderLoaded(e: any): void {
    let reader = e.target;
    this.file = reader.result;

    this.enableUpload.emit(true);
  }

  checkFile(): void{
    if(this.file){
      let pattern = /html/;
      if (!this.file.type.match(pattern)) {
        this.generalFunctionsService.showWarning(this.translate.instant('common.fileInvalid'));
        return;
      }

      this.fileReader = new FileReader();
      this.fileReader.onload = this.handleReaderLoaded.bind(this);
      this.fileReader.readAsDataURL(this.file);
    } else {

      this.enableUpload.emit(false);
    }
    this.sendFile.emit({file: this.file, imageData: "emailReceipt"});
  }

  onFilesChange(file: File): void{
    this.file = file;
    this.checkFile();
  }

  onFileInvalids(error: string): void{
    this.generalFunctionsService.showWarning(error);
  }
}

